<mat-card style="padding-bottom: 10px;" id="update-pharmacy">
  <app-matspinner *ngIf="isLoading"></app-matspinner>
  <mat-card-header>
    <mat-card-title class="title">Update Pharmacy Chain</mat-card-title>
  </mat-card-header>
  <mat-divider class="divider" style="margin-bottom: 100px;"></mat-divider>
  <mat-card-content>
    <mat-card>
      <br>
      <div class="container header-section">
        <form [formGroup]="form">
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Name</label><span class="asterick">*</span>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input matInput formControlName="PharmacyName" placeholder="Name (Max length is 50 characters)" required
                  class="maxLength50" (keyup)="clearPharmacyNameDuplicateValidation();">
                <mat-error>{{errorMessageForPharmacyName}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <label class="lbl_fld">Billing Group</label>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input matInput formControlName="BillingGroup" placeholder="Billing Group (Max length is 4 characters)" (change)="onBillingGroupChange($event)">
                <mat-error>{{errorMessageForBillingGroup}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Vela PID</label><span class="asterick">*</span>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input matInput formControlName="PID" placeholder="Vela PID (Max length is 20 characters)" 
                  (keyup)="clearPIDDuplicateValidation();">
                <mat-error>{{errorMessageForPID}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <label class="lbl_fld">Billing Region</label>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input matInput formControlName="BillingRegion" placeholder="Billing Region (Max length is 2 characters)" (change)="onBillingRegionChange($event)">
                <mat-error>{{errorMessageForBillingRegion}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Activation Date</label><span class="asterick">*</span>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input name="EffectiveDate" matInput [matDatepicker]="effpicker" formControlName="EffectiveDate"
                  placeholder="MM/DD/YYYY">
                <mat-datepicker-toggle matIconSuffix [for]="effpicker"></mat-datepicker-toggle>
                <mat-datepicker #effpicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <label class="lbl_fld">Pet Transactions Enabled</label>
            </div>
            <div class="col-md-4" style="display: flex; align-items: center;">
              <mat-checkbox color="primary" style="transform: scale(1.64); margin-top: -10px; margin-left: 0px;" formControlName="PetEnabled"></mat-checkbox>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Deactivation Date</label>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <input name="TermDate" matInput [matDatepicker]="termpicker" formControlName="TermDate"
                  (dateChange)="onDateSelect($event)" (keyup)='onDateInputkeyup($event)'
                  placeholder="MM/DD/YYYY" [min]="minTermDate">
                <mat-datepicker-toggle matIconSuffix [for]="termpicker"></mat-datepicker-toggle>
                <mat-datepicker #termpicker></mat-datepicker>
                <mat-error>{{errorMessageForTermDate}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-2">
              <label class="lbl_fld">Pharmacy Chain Active</label>
            </div>
            <div class="col-md-4" style="display: flex; align-items: center;">
              <mat-checkbox color="primary" style="transform: scale(1.64); margin-top: -10px; margin-left: 0px;" formControlName="IsEnabled" (change)="onEnabledChange($event)">
              </mat-checkbox>
              <mat-error style="margin-bottom: 12px; margin-left: 15px;"> {{errorMessageForIsEnabled}}</mat-error>
            </div>
          </div>
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Vendor</label><span class="asterick">*</span>
            </div>
            <div class="col-md-4">
              <mat-form-field class="ffs" appearance="outline">
                <mat-select 
                  placeholder="Select Vendor"
                  required
                  formControlName="Vendor"
                  ngDefaultControl
                  id="Vendor"
                  [panelClass]="'vendor-panel-position'"
                  (selectionChange)="onVendorChange($event.value)">
                  <mat-option *ngFor="let vendor of vendorList" 
                  [value]="vendor.VendorId">
                    {{ vendor.VendorName }}
                  </mat-option>
                </mat-select>
              <mat-error>{{errorMessageForVendor}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Connectivity Mode Buttons (copied from pharmacy-add) -->
          <div class="row form-row">
            <div class="col-md-2">
              <label class="lbl_fld">Connectivity Mode</label>
            </div>
            <div class="col-md-6">
              <div class="button-toggle" style="gap: 8%;">
                <button type="button"
                  [class.active]="!useVendorLevelConnectivityToggle"
                  (click)="toggleVendorLevelConnectivity(false)">
                  Pharmacy-Level Connectivity
                </button>
                <button type="button"
                  [class.active]="useVendorLevelConnectivityToggle"
                  (click)="toggleVendorLevelConnectivity(true)">
                  Vendor-Level Connectivity
                </button>
              </div>
            </div>
          </div>

          <mat-divider class="divider" style="margin-top: 2%;margin-bottom: 2%;"></mat-divider>
          <app-connection-details *ngIf="showConnectionDetails()" [inputModel]="pharmacyModel"> </app-connection-details>
          <br>
          <div class="row" style="margin-bottom: 0%;">
            <div class="col-md-12" style="text-align: center;">
              <button mat-raised-button color="primary" class="btn-save"
                [disabled]="isUpdateButtonDisabled()"
                (click)="submitForm()">Update</button>
              <button mat-raised-button color="primary" class="btn-cancel" (click)="onClickCancel()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </mat-card>
    <br>
    <div class="container" style="margin-top: 15px;">
      <mat-card-title>Stores</mat-card-title>
      <div class="row form-row" style="margin-top: 5px; align-items: center;">
        <div class="col-md-6">
          <mat-form-field class="ffs" appearance="outline" style="width: 700px; max-width: 700px; margin-left: 0%;">
            <input matInput (keyup)="applyFilter($event)" placeholder="Search Stores" #input>
          </mat-form-field>
        </div>
        <div class="col-md-5" style="text-align: right; margin-bottom: 0%;">
          <button mat-raised-button color="primary" class="btn-save" (click)="showNCPDPIDPopup()" style="margin-right: 40px;">Add Store</button>
          <button mat-raised-button color="primary" class="btn-save" (click)="ExportToExcel()">Export</button>
        </div>
      </div>
      <div class="mat-elevation-z8 table-container" style="width: 42%; text-align:center">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="NCPDPID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Pharmacy NCPDP ID </th>
            <td mat-cell *matCellDef="let row"> {{row.NCPDPID}} </td>
          </ng-container>
          <ng-container matColumnDef="RecordActiveDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Record Active Date </th>
            <td mat-cell *matCellDef="let row"> {{row.RecordActiveDate | date:'MM/dd/yyyy'}} </td>
          </ng-container>
          <ng-container matColumnDef="RecordDeactivateDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Record Deactivate Date </th>
            <td mat-cell *matCellDef="let row"> {{row.RecordDeactivateDate | date:'MM/dd/yyyy'}} </td>
          </ng-container> 
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef>Delete</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" (click)="open(content,element.NCPDPID)">
                <mat-icon class="mat-18">delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No Stores Found</td>
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 30, 50, 100]" aria-label="Select page of users"></mat-paginator>




        <ng-template #content let-c="close" let-d="dismiss">

          <div class="modal-body">
            <p>Are you sure you would like to delete this Pharmacy NCPDP ID - {{ ncpdpid}}? </p>
          </div>
          <div class="modal-footer" style="">
            <button mat-raised-button  class="btn-cancel"
              (click)="d('Cross click')">Cancel</button>
            <button mat-raised-button class="btn-save" (click)="c('yes')">Delete</button>
          </div>

        </ng-template>
      </div>
      <br>
    </div>
  </mat-card-content>
  <br>
  <br>
</mat-card>